import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecom-invalid-page',
  templateUrl: './ecom-invalid-page.component.html'
})
export class InvalidComponent implements OnInit {

  linkExpired = false;
  constructor() { }

  ngOnInit() {
   
  }



}
